import { apiEndpoint } from "../config.json";
import http from "./httpService";

export function signin(credentials) {
    return http.post(apiEndpoint + "login", credentials);
}
